import { createRootRoute, Outlet } from '@tanstack/react-router'
import { QueryClientProvider } from '@tanstack/react-query'
import { lazy, Suspense } from 'react'
import { queryClient } from '../lib/query-client'
import { useUIStore } from '../stores/ui-store'
import { useAuth } from '../hooks/useAuth'
import { ToastContainer } from '../components/Toast'

const TanStackRouterDevtools = import.meta.env.DEV
  ? lazy(() =>
      import('@tanstack/router-devtools').then((mod) => ({
        default: mod.TanStackRouterDevtools,
      })),
    )
  : () => null

const ReactQueryDevtools = import.meta.env.DEV
  ? lazy(() =>
      import('@tanstack/react-query-devtools').then((mod) => ({
        default: mod.ReactQueryDevtools,
      })),
    )
  : () => null

export const Route = createRootRoute({
  component: RootLayout,
})

function RootLayout() {
  const theme = useUIStore((s) => s.theme)

  // Trigger initial auth check on app mount
  useAuth()

  return (
    <QueryClientProvider client={queryClient}>
      <div
        className={`${theme} min-h-screen bg-[var(--color-surface)] text-[var(--color-text-primary)]`}
      >
        <Outlet />
      </div>
      <ToastContainer />
      <Suspense>
        <TanStackRouterDevtools position="bottom-right" />
        <ReactQueryDevtools buttonPosition="bottom-left" />
      </Suspense>
    </QueryClientProvider>
  )
}
